import React from "react";
import { motion } from "framer-motion";
import { INCLUDED, NOT_INCLUDED, PAYMENT_INFO } from "../data";
import { Check, X, CreditCard } from "lucide-react";

const Included = () => {
  return (
    <section className="relative py-24 md:py-32" style={{ background: "var(--ocean-deep)" }} data-testid="included-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16 max-w-2xl">
          <div className="overline mb-4">Transparência total</div>
          <h2 className="font-display text-4xl md:text-5xl font-light leading-tight">
            O que está, o que não está, e como pagar.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="glass p-8"
          >
            <div className="overline mb-5" style={{ color: "#7CE5A4" }}>Incluso no pacote</div>
            <ul className="space-y-3">
              {INCLUDED.map((i) => (
                <li key={i} className="flex items-start gap-3 text-sm">
                  <Check size={16} style={{ color: "#7CE5A4", marginTop: 2 }} />
                  <span>{i}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="glass p-8"
          >
            <div className="overline mb-5" style={{ color: "var(--ocean-coral)" }}>Não incluso</div>
            <ul className="space-y-3">
              {NOT_INCLUDED.map((i) => (
                <li key={i} className="flex items-start gap-3 text-sm">
                  <X size={16} style={{ color: "var(--ocean-coral)", marginTop: 2 }} />
                  <span style={{ color: "var(--ocean-muted)" }}>{i}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="glass p-8"
          >
            <div className="overline mb-5 flex items-center gap-2" style={{ color: "var(--ocean-accent)" }}>
              <CreditCard size={14} /> Formas de pagamento
            </div>
            <div className="mb-5 p-4" style={{ background: "rgba(245,199,84,0.08)", border: "1px solid rgba(245,199,84,0.35)" }}>
              <div className="font-display text-2xl" style={{ color: "var(--ocean-accent)" }}>
                {PAYMENT_INFO.highlight}
              </div>
              <div className="text-xs mt-1" style={{ color: "var(--ocean-muted)" }}>
                A forma mais utilizada pelos nossos hóspedes
              </div>
            </div>
            <ul className="space-y-3">
              {PAYMENT_INFO.items.map((i) => (
                <li key={i} className="flex items-start gap-3 text-sm">
                  <span className="block w-1 h-1 rounded-full mt-2" style={{ background: "var(--ocean-accent)" }} />
                  <span>{i}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Included;
